import { z } from 'zod'
import { serviceWaypointLoadSchema } from './serviceWaypointLoadSchema'

export const serviceWaypointSchema = z.object({
  id: z.number().optional(),
  serviceId: z.number().optional(),
  waypointId: z.number().optional(),
  loads: z.array(serviceWaypointLoadSchema).optional(),
})
